import { useRouter } from 'next/router'

export const useReload = () => {
  const router = useRouter()

  // 备注：这种页面重渲染的方式，相当于重新执行服务端请求 + 组件更新，但不会清除表单等数据，useState也不会再执行
  // TODO 等验证实用后，在大面积推广
  const reload = () => {
    router.push(router.asPath)
  }

  return { reload }
}
